import DamageTypePage from "@/components/damageType/DamageTypePage";

const DsgvoBussgelder = () => <DamageTypePage slug="dsgvo-bussgelder" />;
export default DsgvoBussgelder;
